<template>
<section class="connect-card brand-panel">
  <div class="connect-header">
    <div>
      <span class="brand-kicker">Twitch</span>
      <h2>Channel connection</h2>
    </div>
    <div class="status-pill" :class="{ ready: connection.status, waiting: connection.status === false }">
      <div v-if="connection.status === null" class="spinner-grow spinner-grow-sm" role="status">
          <span class="sr-only"></span>
      </div>
      <span v-else-if="connection.status">Connected</span>
      <span v-else>Not connected</span>
    </div>
  </div>

  <div v-if="connection.status" class="connect-body">
      <dl class="detail-list">
        <div>
          <dt>Twitch username</dt>
          <dd>{{ connection.username }}</dd>
        </div>
        <div>
          <dt>Twitch id</dt>
          <dd>
            <span v-if="connection.userId !== null">{{ connection.userId }}</span>
            <span v-else>unknown</span>
          </dd>
        </div>
      </dl>

      <a href="https://store.steampowered.com/app/2185040/Sidestream_Games/" class="btn btn-success btn-lg w-100">Download Client on Steam</a>
  </div>

  <div v-if="!connection.status && connection.status !== null" class="connect-body">
      <p class="connect-copy">Authorize Sidestream with Twitch so chat commands can flow into your game session.</p>
      <a
          :href="'https://id.twitch.tv/oauth2/authorize?response_type=code&client_id=f7kkzh0fsyeukb08yg791qh847aivx&scope=channel:moderate+chat:edit+chat:read&state=' + connection.stateCode + '&redirect_uri=' + connection.redirectUrl"
          type="button"
          class="btn btn-outline-primary btn-lg w-100"
      >
          Connect Twitch
      </a>
  </div>

  <b-alert class="mt-3" v-model="connection.twitchIdUnavailable" variant="danger">This Twitch account ({{ connection.alreadyUsedUsername }}) is already integrated with another user.</b-alert>
</section>
</template>

<script>
    import Vue from 'vue'
    import TwitchService from '@/services/twitch.service.js';
    import { BAlert } from 'bootstrap-vue'

    Vue.component('b-alert', BAlert);

    export default {
        name: 'TwitchConnect',

        data () {
            return {
                connection: {
                    status: null,
                    login: null,
                    username: null,
                    userId: null,
                    stateCode: TwitchService.getStateCode(),
                    redirectUrl: TwitchService.getRedirectUrl(),
                    twitchIdUnavailable: false,
                    alreadyUsedUsername: "",
                },
            }
        },

        mounted: function() {

            handleQuery(this, this.$route.query)
                .then(() => {
                    updateStatus(this);
                })
                .catch(() => {
                    if (this.$route.path == '/connect') {
                        this.$router.replace({ path: '/' });
                    }
                    updateStatus(this);
                });

        }
    }


    function updateStatus(self) {

        TwitchService.getStatus()
        .then(response => {
            if (response.data['token'] !== undefined) {
                self.connection.status = true;
                self.connection.username = response.data['login'];
                self.connection.userId = response.data['user_id'];
            }
        })
        .catch(error => {
            if (error.response.status == 404) {
                self.connection.status = false;
            }
            if (error.response.status == 403) {
                self.connection.status = false;
                self.connection.twitchIdUnavailable = true;
                self.connection.alreadyUsedUsername = error.response.data['login'];
            }
        });

    }


    function handleQuery(self, params) {
        const sc = TwitchService.getStateCode();
        if (sc === null) {
            return Promise.reject();
        }

        if (sc != params['state']) {
            return Promise.reject();
        }

        const code = params['code'];
        if (code === undefined) {
            return Promise.reject();
        }

        TwitchService.clearStateCode();

        // Send auth request to the backend
        return TwitchService.sendAuth(code);
    }

</script>

<style scoped>
.connect-card {
  padding: 1.35rem;
}

.connect-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.connect-header h2 {
  margin: 0;
  font-size: 1.65rem;
}

.status-pill {
  min-width: 8.5rem;
  padding: 0.55rem 0.85rem;
  border: 2px solid var(--ss-line);
  border-radius: 999px;
  background: #fff0a4;
  text-align: center;
  font-weight: 950;
}

.status-pill.ready {
  background: #d9ffd8;
}

.status-pill.waiting {
  background: #fff0a4;
}

.connect-copy {
  margin-bottom: 1rem;
  color: var(--ss-muted);
  font-weight: 700;
}

.detail-list {
  display: grid;
  gap: 0.75rem;
  margin: 0 0 1rem;
}

.detail-list div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem;
  border: 2px solid rgba(22, 20, 15, 0.15);
  border-radius: 8px;
  background: rgba(255, 216, 77, 0.16);
}

.detail-list dt,
.detail-list dd {
  margin: 0;
}

.detail-list dt {
  color: var(--ss-muted);
  font-size: 0.78rem;
  font-weight: 900;
  text-transform: uppercase;
}

.detail-list dd {
  font-weight: 950;
}

@media (max-width: 520px) {
  .connect-header,
  .detail-list div {
    display: grid;
  }

  .status-pill {
    width: 100%;
  }
}
</style>
